import { types, flow, applySnapshot, getSnapshot } from 'mobx-state-tree';
import { makeRequest, errorResponse } from 'js/services/Network';

import TransactionsPaginator from './TransactionsPaginator';
import OrderStatusesPaginator from './OrderStatusesPaginator';
import orderStatusTranslation from 'js/config/orderStatusTranslation';

export default types
  .model('Order', {
    isLoading: false,
    error: types.maybeNull(types.string),

    uid: types.string,
    title: types.maybe(types.string),
    seller_name: types.maybe(types.string),
    seller_email: types.maybe(types.string),
    seller_address: types.maybe(types.string),
    buyer_name: types.maybe(types.string),
    buyer_email: types.maybe(types.string),
    buyer_address: types.maybe(types.string),
    image: types.maybe(types.string),
    updated_at: types.maybe(types.string),
    status: types.maybe(types.string),
    price: types.maybe(types.number),
    item_size: types.maybe(types.string),
    item_alias: types.maybe(types.string),
    item_mode: types.maybe(types.string),
    deliver_shipment_id: types.maybeNull(types.number),
    return_shipment_id: types.maybeNull(types.number),
    shipper: types.maybeNull(types.string),

    seconds_until_completion: types.maybe(types.number),
    completion_time: types.maybe(types.string),
    seconds_until_expiration: types.maybe(types.number),
    expiration_time: types.maybe(types.string),
    seconds_until_returned: types.maybe(types.number),
    returned_time: types.maybe(types.string),

    transactions: types.optional(TransactionsPaginator, {}),
    statuses: types.optional(OrderStatusesPaginator, {}),
  })
  .views(self => ({
    get human_status() {
      return orderStatusTranslation[self.status] || `Unknown status (${self.status})`;
    },
  }))
  .actions(self => ({
    afterCreate() {
      self.transactions.uid = self.uid;
      self.transactions.load();
      self.statuses.uid = self.uid;
      self.statuses.load();
    },
    load: flow(function* load() {
      let response;

      if (!self.isLoading) {
        self.isLoading = true;
        self.error = null;

        try {
          response = yield makeRequest('admin-order-data', null, { uid: self.uid });
          applySnapshot(self, { ...getSnapshot(self), ...response.data });
        } catch (error) {
          self.error = errorResponse(error);
        }

        self.isLoading = false;
      }

      return response;
    }),
  }));
